<template>
    <div class="v-tabs-wrapper date-picker">
        <v-tabs v-if="selectedChart === 'market-value'" fixed-tabs show-arrows v-model="selectedMarketValueTab">
            <v-tab v-on:click="onMVTabClick('1m')">{{ $t('period-1m') }}</v-tab>
            <v-tab v-on:click="onMVTabClick('6m')">{{ $t('period-6m') }}</v-tab>
            <v-tab v-on:click="onMVTabClick('1y')">{{ $t('period-1y') }}</v-tab>
            <v-tab v-on:click="onMVTabClick('all')">{{ $t('period-all') }}</v-tab>
        </v-tabs>

        <v-tabs v-if="selectedChart === 'bottles-number'" fixed-tabs show-arrows v-model="selectedBottlesNumberTab">
            <v-tab v-on:click="onBottlesTabClick('1m')">{{ $t('period-1m') }}</v-tab>
            <v-tab v-on:click="onBottlesTabClick('6m')">{{ $t('period-6m') }}</v-tab>
            <v-tab v-on:click="onBottlesTabClick('1y')">{{ $t('period-1y') }}</v-tab>
            <v-tab v-on:click="onBottlesTabClick('all')">{{ $t('period-all') }}</v-tab>
        </v-tabs>
    </div>
</template>

<script>
export default {
    name: "DatePicker",
    props: ["selectedChart"],
    data() {
        return {
            selectedMarketValueTab: 2,
            selectedBottlesNumberTab: 2
        }
    },
    mounted() {
        if (localStorage.getItem('selectedMarketValuePeriod') && this.selectedChart === 'market-value') {
            switch (localStorage.getItem('selectedMarketValuePeriod')) {
                case '1m':
                    this.selectedMarketValueTab = 0
                    break;
                case '6m':
                    this.selectedMarketValueTab = 1
                    break;
                case '1y':
                    this.selectedMarketValueTab = 2
                    break;
                case 'all':
                    this.selectedMarketValueTab = 3
                    break;
                default:
                    this.selectedMarketValueTab = 3
                    break;
            }
        } else if (localStorage.getItem('selectedBottlesPeriod') && this.selectedChart === 'bottles-number') {
            switch (localStorage.getItem('selectedBottlesPeriod')) {
                case '1m':
                    this.selectedBottlesNumberTab = 0
                    break;
                case '6m':
                    this.selectedBottlesNumberTab = 1
                    break;
                case '1y':
                    this.selectedBottlesNumberTab = 2
                    break;
                case 'all':
                    this.selectedBottlesNumberTab = 3
                    break;
                default:
                    this.selectedBottlesNumberTab = 3
                    break;
            }
        } else {
            this.selectedMarketValueTab = 3
            this.selectedBottlesNumberTab = 3
        }
    },
    methods: {
        onMVTabClick(period) {
            this.$emit('onMarketValueDatePick', period)
            localStorage.setItem('selectedMarketValuePeriod', period)
        },
        onBottlesTabClick(period) {
            this.$emit('onBottlesDatePick', period)
            localStorage.setItem('selectedBottlesPeriod', period)
        }
    }
};
</script>

<style scoped>
.date-picker {
    margin-top: 30px;
}
</style>
<style>
.wine-details-page .v-slide-group__wrapper {
    max-width: 100%;
}

.wine-details-page .v-slide-group__content {
    border: none;
}

.wine-details-page .v-tab {
    color: #000 !important;
    padding: 0;
    letter-spacing: normal;
}

.wine-details-page .v-tab.v-tab--active, .wine-details-page .v-tab.v-tab--active:hover .vertical-tabs-label, .wine-details-page .v-tab:hover {
    color: var(--blue) !important;
    cursor: pointer;
    background-color: var(--semi-white);
    position: relative;
}

.wine-details-page .v-tab.v-tab--active .vertical-tabs-label:before,
.wine-details-page .v-tab.v-tab--active:hover .vertical-tabs-label:before,
.wine-details-page .v-tab:before,
.wine-details-page .v-tab:hover .vertical-tabs-label:before {
    content: "";
    width: 6px;
    height: 48px;
    position: absolute;
    top: -16px;
    left: 2px;
    z-index: 100;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    transform: translateX(-50%);
    background-color: var(--blue);
}

.wine-details-page .v-item-group.theme--light.v-slide-group {
    max-width: 100%;
    width: 100%;
    height: 32px;
    background: rgba(0, 0, 0, .04);
    border-radius: 4px;
}

.wine-details-page .v-tab.v-tab--active {
    background-color: var(--white) !important;
    border-radius: 4px;
}

.wine-details-page .v-tabs-slider-wrapper {
    display: none;
}

.wine-details-page .theme--light.v-tabs .v-tab:hover:before {
    opacity: 0;
}
</style>
